import React, {useState} from 'react';

import {Link, useParams} from "react-router-dom";
import {Level9} from "../../../services/metadata.service";
import DisplayMetaWithImport from "../components/DisplayMetaWithImport.comp";
import {formatDate} from "../../../utils/utils";

// name: display on preview top
// key: column# of excel sheet
// json_key: key for posting data to api

const columns = [
    {name: 'Code', key: 0, json_key: 'code', data_key: 'code'},
    {name: 'Full Name', key: 1, json_key: 'full_name', data_key: 'full_name'},
    {name: 'Definition', key: 2, json_key: 'definition', data_key: 'definition'},
    {name: 'Level-8', key: 4, json_key: 'lvl8_code', data_key: 'lvl8_code'},
    {name: 'Level-6', key: 6, json_key: 'lvl6_code', data_key: 'lvl6_code'},
    {name: 'Category 4', key: 3, json_key: 'category_4', data_key: 'category_4'},
    {name: 'MB#', key: 8,  json_key: 'mb_no', data_key: 'mb_no'},
    {name: 'DQC#', key: 9, json_key: 'dqc_no', data_key: 'dqc_no'},
    {name: 'DQ#', key: 10, json_key: 'dq_no', data_key: 'dq_no'},
    {name: 'DQM#', key: 11, json_key: 'dqm_no', data_key: 'dqm_no'},
    {name: 'DQA#', key: 12, json_key: 'dqa_no', data_key: 'dqa_no'},
]

const tableCols = [
    {
        label: 'Code',
        field: 'code', width: 150
    },
    {
        label: 'Full Name',
        field: 'full_name', width: 150
    },
    {
        label: 'Definition',
        field: 'definition', sort: 'disabled', width: 150
    },
    {
        label: 'Level 8',
        field: 'lvl8_code', width: 150
    },
    {
        label: 'Level 6',
        field: 'lvl6_code', width: 150
    },
    {
        label: 'Category 4',
        field: 'category_4', sort: 'asc', width: 150
    },
    {
        label: 'MB#',
        field: 'mb_no', sort: 'asc', width: 150
    },
    {
        label: 'DQC#',
        field: 'dqc_no', sort: 'asc', width: 150
    },
    {
        label: 'DQ#',
        field: 'dq_no', sort: 'asc', width: 150
    },
    {
        label: 'DQM#',
        field: 'dqm_no', sort: 'asc', width: 150
    },
    {
        label: 'DQA#',
        field: 'dqa_no', sort: 'asc', width: 150
    },
    {
        label: 'Created',
        field: 'createdAt', width: 150
    },
    {
        label: 'Updated',
        field: 'updatedAt', width: 150
    },
    {
        label: 'Actions',
        field: 'actions', sort: 'disabled', searchable: false
    }
]



const Level9Page = () => {

    const { url_param_str } = useParams();
    const search_query = url_param_str.split('=').length > 1 ? url_param_str.split('=')[1]  : '';

    const table_row__additional_rendering = (row) => {
       
        const create_data = formatDate(row.createdAt) + ',\n ' + (row.createdBy ? row.createdBy : '');
        row.createdAt = create_data;

        const update_data = formatDate(row.updatedAt) + ',\n ' + (row.updatedBy ? row.updatedBy : '');
        row.updatedAt = update_data;

        return row;
    }

    return (
        <DisplayMetaWithImport
            title={'Level 9'}
            modal_title={'Level 9 - Data Preview'}
            sheet_name={'Level9'}
            columns={columns}
            tableCols={tableCols}
            search_query={search_query}
            tableSpRender={table_row__additional_rendering}
            listAPI={Level9.listData}
            postAPI={Level9.postData}
            deleteAPI={Level9.deleteEntity}
            updateAPI={Level9.updateEntity}
            preRemoveAPI={Level9.preRemoveCheck}
        />
    );
}

export default Level9Page;


